// content-switcher.js
;(({ $$ }) => {
    const activeSectionsClass = 'content-switcher__section--active'
    $$('.content-switcher').forEach(switcher => {
        const sections = switcher.querySelectorAll('.content-switcher__section')
        const internalTriggers = switcher.querySelectorAll('.content-switcher__trigger')
        const initIndex = parseInt(switcher.dataset.switcherInitIndex) || 0
        const switcherSet = switcher.dataset.switcherSet

        setActiveIndex(sections, initIndex)

        // Get external triggers and combine its with internal
        const triggers = [ 
            ...internalTriggers,
            ...$$(`[data-switcher-external-set="${switcherSet}"]`)
        ]

        triggers.forEach(trigger => {
            const targetIndex = parseInt(trigger.dataset.switcherTargetIndex)
            if (targetIndex == undefined) return

            trigger.addEventListener('click', e => {
                e.preventDefault()
                setActiveIndex(sections, targetIndex)
            })
        })
    })

    function setActiveIndex(sections, index) {
        if (sections.length == 0) return

        sections.forEach(s => s.classList.remove(activeSectionsClass))
        if (index < sections.length) {
            sections[index].classList.add(activeSectionsClass)
        } else {
            sections[0].classList.add(activeSectionsClass)
        }
    }
})(CNS);